/* This reducer takes care of storing the necessary information to show/hide
 * the main error overlay. This will avoid a codepath in the main payment
 * widget component that checks for `error` object on all the required child
 * states like payWithDetails etc. Doing this will ensure that if we have to
 * handle the errors of a new API call we add in the future, the PaymentWidget
 * component doesn't need any changes.
 */
import * as Actions from 'actions/PaymentActions/PaymentActions';
import * as constants from 'pages/PaymentsPage/PaymentOptions/constants';
export const INITIAL_STATE = {};
export default function errorOverlayReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case Actions.GET_PAYMENT_OPTIONS_ERROR:
            if (action.status === constants.NETWORK_ERROR.KNOWN_PAYMENT_ERROR) {
                return { error: action.error, status: action.status };
            }
            // This is a special case because showing a "something went wrong"
            // message with "payment if done will be refunded" style message
            // (which is the default) doesn't make sense if payment options
            // weren't even shown!
            return { error: action.error, status: constants.NETWORK_ERROR.PAYMENT_OPTIONS_LOAD_ERROR };
        case Actions.PAY_WITH_DETAILS_ERROR:
        case Actions.PAY_ERROR:
        case Actions.PAY_VIA_WALLET_ERROR:
        case Actions.GET_CAPTCHA_ERROR:
        case Actions.OTP_MODES_ERROR:
        case Actions.OTP_SUBMIT_ERROR:
        case Actions.VOUCHER_ADD_OR_SELECT_ERROR:
        case Actions.UPI_STATUS_POLL_ERROR:
        case Actions.UPI_STATUS_POLL_TIMEOUT_ERROR:
            return { error: action.error, status: action.status };
        case Actions.RESET_ERROR_OVERLAY_ACTION:
            return INITIAL_STATE;
        default:
            return state;
    }
}
